// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-ugc-box .wm-box {
  position: relative;
  margin: 10px;
  border-radius: 15px;
  box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.1);
  transition: all 500ms;
  height: 100%;
  max-height: 176px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: stretch;
}
wm-ugc-box .wm-box .color {
  position: absolute;
  border-radius: 15px;
  clip-path: polygon(100% 0, calc(100% - 30px) 0, 100% 30px);
  box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.1);
  height: 100%;
  width: 100%;
  z-index: 1;
  background-color: #ca1551;
}
wm-ugc-box .wm-box .wm-box-icon {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  margin: 0;
  height: 48px;
  width: 48px;
  margin: 10px;
  border-width: 1px;
  z-index: 2;
}
wm-ugc-box .wm-box .wm-box-icon svg {
  height: 100%;
}
wm-ugc-box .wm-box wm-img {
  height: 100%;
}
wm-ugc-box .wm-box wm-img img {
  position: absolute;
  border-radius: 15px;
  object-fit: cover;
  align-self: stretch;
  height: 100%;
  width: 100%;
  filter: brightness(75%);
}
wm-ugc-box .wm-box .wm-box-title {
  font-size: 26px;
  font-family: var(--wm-font-family-content, inherit);
  font-style: normal;
  font-weight: 700;
  color: white;
  position: absolute;
  bottom: 0;
  padding: 6%;
  line-height: 31px;
  letter-spacing: 0em;
  text-align: left;
  white-space: break-spaces;
}
wm-ugc-box .wm-box wm-privacy-agree-button {
  position: absolute;
  bottom: 35px;
  left: 6%;
  right: 6%;
  width: 88%;
}
wm-ugc-box .wm-box wm-privacy-agree-button ion-button {
  font-weight: 600;
  margin: 0;
  width: 100%;
  height: 32px;
  font-size: 12px;
}
wm-ugc-box ion-button {
  position: absolute;
  width: 40px;
  height: 40px;
  top: 0;
  left: 0;
  margin: 10px;
  --padding-start: 0.5em;
  --padding-end: 0.5em;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/box/ugc-box/ugc-box.component.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,8CAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EAEA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,2BAAA;EACA,sBAAA;EACA,oBAAA;AADJ;AAEI;EACE,kBAAA;EACA,mBAAA;EACA,0DAAA;EACA,8CAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;AAAN;AAEI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EAEA,iBAAA;EAIA,UAAA;AAJN;AACM;EACE,YAAA;AACR;AAGI;EACE,YAAA;AADN;AAEM;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;AAAR;AAII;EACE,eAAA;EACA,mDAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EAEA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;AAHN;AAOI;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AALN;AAOM;EACE,gBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AALR;AAUE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,sBAAA;EACA,oBAAA;AARJ","sourcesContent":["wm-ugc-box {\n  .wm-box {\n    position: relative;\n    margin: 10px;\n    border-radius: 15px;\n    box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.1);\n    transition: all 500ms;\n    height: 100%;\n    max-height: 176px;\n    cursor: pointer;\n\n    display: flex;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n    align-content: stretch;\n    align-items: stretch;\n    .color {\n      position: absolute;\n      border-radius: 15px;\n      clip-path: polygon(100% 0, calc(100% - 30px) 0, 100% 30px);\n      box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.1);\n      height: 100%;\n      width: 100%;\n      z-index: 1;\n      background-color: #ca1551;\n    }\n    .wm-box-icon {\n      position: absolute;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      margin: 0;\n      height: 48px;\n      width: 48px;\n      margin: 10px;\n\n      border-width: 1px;\n      svg {\n        height: 100%;\n      }\n      z-index: 2;\n    }\n    wm-img {\n      height: 100%;\n      img {\n        position: absolute;\n        border-radius: 15px;\n        object-fit: cover;\n        align-self: stretch;\n        height: 100%;\n        width: 100%;\n        filter: brightness(75%);\n      }\n    }\n\n    .wm-box-title {\n      font-size: 26px;\n      font-family: var(--wm-font-family-content, inherit);\n      font-style: normal;\n      font-weight: 700;\n      color: white;\n      position: absolute;\n      bottom: 0;\n      padding: 6%;\n\n      line-height: 31px;\n      letter-spacing: 0em;\n      text-align: left;\n      white-space: break-spaces;\n    }\n\n    // Stili per il privacy agree button\n    wm-privacy-agree-button {\n      position: absolute;\n      bottom: 35px;\n      left: 6%;\n      right: 6%;\n      width: calc(100% - 12%);\n\n      ion-button {\n        font-weight: 600;\n        margin: 0;\n        width: 100%;\n        height: 32px;\n        font-size: 12px;\n      }\n    }\n  }\n\n  ion-button {\n    position: absolute;\n    width: 40px;\n    height: 40px;\n    top: 0;\n    left: 0;\n    margin: 10px;\n    --padding-start: 0.5em;\n    --padding-end: 0.5em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
